<template>
    <views class="search">
        <views class="search-inner" @click="goSearch">
            <views class="search-icon">
                <images :src="searchIcon"></images>
            </views>
            <views
                :class="{'dark': querys.keyword}"
                class="search-input">
                {{ keyword }}
            </views>
        </views>
    </views>
</template>

<script>
import tools from '@/mixins/tools'
export default {
    mixins: [tools],
    props: {
        path: String,
        querys: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            searchIcon: require('@/assets/images/sy_ss@3x.png')
        }
    },
    computed: {
        keyword() {
            return this.querys.keyword ? this.querys.keyword : '请输入搜索标题'
        }
    },
    methods: {
        goSearch() {
            this.push(`/search?${this.path}&keyword=${this.querys.keyword || ''}`)
        }
    }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
